import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BaseFieldComponentInterface } from "./base-field.component.interface";
import { FieldTypes } from "@nts/std/types";

@Component({
    template: '',
    selector: 'nts-base-field',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class BaseFieldComponent implements BaseFieldComponentInterface {
    type: FieldTypes;
    additionalField = false;
    isHidden: boolean;
    abstract get path(): string;
    abstract get name(): string;
    abstract get fullColumn(): boolean;
    abstract get description(): string;
    abstract get displayName(): string;
    abstract get isDisabled(): boolean;
}
